import { mapState } from "vuex";
import { __generateData } from "@/assets/js/Renderer/generatorsFns";

export default {
    data() {
        return {
            listContainers: ["ctrl-panel", "ctrl-segment"],
            listInputs: ["ctrl-textbox"]
        };
    },
    computed: {
        ...mapState("components", ["components", "sidebarComponents"])
    },
    methods: {
        randomBool() {
            return Math.random() >= 0.5;
        },
        randomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        randomElement() {
            const elements = [...this.listInputs, ...this.listContainers];
            // const elements = [...this.listContainers];

            return elements[this.randomInt(0, elements.length - 1)];
        },
        newElement(elementType = this.randomElement()) {
            const element = {
                guid: this.newGuid(),
                body: []
            };
            const properties = this.getElementProperties(elementType, element.guid);

            return { element, properties };
        },
        randomInput() {
            return ""; // this.listInputs[this.randomInt(0, this.listInputs.length - 1)];
        },
        newInputElement() {
            return this.newElement(this.randomInput());
        },
        randomContainer() {
            return this.listContainers[this.randomInt(0, this.listContainers.length - 1)];
        },
        newContainerElement() {
            return this.newElement(this.randomContainer());
        },
        randomBodyFill() {
            return Array(this.randomInt(1, 5)).fill("").map(() => {
                const { element, properties } = this.newInputElement();

                this.setProperties({ guid: element.guid, properties });

                return element;
            });
        },
        getElementProperties(elementType, guid) {
            const properties = { component: elementType, share: this.randomBool() };

            if (elementType === "ctrl-panel") {
                properties.label = `Panel ${guid}`;
            } else if (elementType === "ctrl-textbox") {
                properties.label = `Textbox ${guid}`;
            } else if (elementType === "ctrl-segment") {
                properties.label = `Segment ${guid}`;
                properties.namespace = true;
            } else if (elementType === "ctrl-select") {
                properties.label = `Select ${guid}`;
                properties.options = [
                    { label: "Test", value: "test" }
                ];
            }

            return properties;
        },
        generateNewBody() {
            const { element, properties } = this.newContainerElement();

            element.body = this.randomBool() ? [this.generateNewBody()] : this.randomBodyFill();
            this.setProperties({ properties, guid: element.guid });

            return element;
        },
        generateTemplate(elements) {
            return Array(elements).fill("").map(() => this.generateNewBody());
        },
        __isNumber(string = "") {
            const reNumber = /^[0-9]*$/g;
            return reNumber.test(string);
        },
        __generateData(body = this.body, nsLength = 1) {
            const { properties, components } = this;
            const { legacyRenderer: legacy } = this.$store.state.components;

            return __generateData(body, { properties, components, nsLength, legacy });
        },
        __listToStringPath(path = []) {
            return path.map((key, idx) => {
                let strKey;

                if (this.__isNumber(key)) {
                    strKey = `[${key}]`;
                } else {
                    strKey = (idx === 0 ? "" : ".") + key;
                }

                return strKey;
            }).join("");
        },
        __isFunction(object) {
            return !!(object && object.constructor && object.call && object.apply);
        }
    }
};
